import React from 'react';
import throttle from 'lodash/throttle';

export const useThrottleValue = <T,>(value: T, delay: number): T => {
  const [ throttledValue, setThrottledValue ] = React.useState(value);

  const throttledSetValue = React.useMemo(
    () => throttle((val: T) => setThrottledValue(val), delay),
    [ delay ]
  );

  React.useEffect(() => {
    throttledSetValue(value);
  }, [ value, throttledSetValue ]);

  React.useEffect(() => {
    return () => {
      throttledSetValue.cancel();
    };
  }, [ throttledSetValue ]);

  return throttledValue;
};
